import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import config from '../../../config';

const SystemPage = lazy(() => import('../components/SystemPage'));

/**
 * System (platform observability) — internal only: the page redirects anyone else, the API answers 403.
 * Not routed at all unless the env config sets systemPage (off in production and preprod).
 */
const SystemRoutes: RouteObject[] = config.systemPage
  ? [
      {
        path: 'system',
        element: <SystemPage />,
      },
    ]
  : [];

export default SystemRoutes;
